import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  routes: [{
      path: '/',
      name: 'login',
      component: () => import('@/views/index')
    },
    {
        path: '/Train',
        name: 'Train',
        component: () => import('@/views/Train')
    },
    {
        path: '/Pollution',
        name: 'Pollution',
        component: () => import('@/views/Pollution')
    },
    {
        path: '/Breathing',
        name: 'Breathing',
        component: () => import('@/views/product/Breathing')
      },
      {
        path: '/Hearing',
        name: 'Hearing',
        component: () => import('@/views/product/Hearing')
      },
      {
        path: '/EyeProtect',
        name: 'EyeProtect',
        component: () => import('@/views/product/EyeProtect')
      },
      {
        path: '/Intelligent',
        name: 'Intelligent',
        component: () => import('@/views/product/Intelligent')
      },
      {
        path: '/Video',
        name: 'Video',
        component: () => import('@/views/product/Video')
    },
    {
        path: '/Accessory',
        name: 'Accessory',
        component: () => import('@/views/product/Accessory')
    },
    {
        path: '/Suggest',
        name: 'Suggest',
        component: () => import('@/views/Suggest')
    },

  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js